import { i18n } from '@/locales';
const t = i18n.t.bind(i18n);
const lc = 'views.baromoney_report.table_header.';
const tableHeaders = [
    {
        title: t(`${lc}title`),
        value: 'title',
        sortable: false,
        width: 280,
        align: 'start',
    },
    {
        title: t(`${lc}amount`),
        value: 'amount',
        sortable: false,
        width: 194,
        align: 'end',
    },
    {
        title: t(`${lc}tax_amount`),
        value: 'taxAmount',
        sortable: false,
        width: 194,
        align: 'end',
    },
    {
        title: t(`${lc}total_amount`),
        value: 'totalAmount',
        sortable: false,
        width: 194,
        align: 'end',
    },
    // vuetify3 에서는 토글 영역 header 없어도 됨
    // {
    //   title: '',
    //   value: 'data-table-expand',
    //   sortable: false,
    //   width: 56,
    //   align: 'center',
    // },
];
// transactions type과 테이블 항목 이름 매핑하기
const reportTypeList = {
    // dep1. 총 수익
    // dep2. 배달 수익
    // 선차감 수익
    MARGIN_FOR_DISTRIBUTOR: 'margin_for_distributor',
    MARGIN_FOR_DISTRIBUTOR_REFUND: 'margin_for_distributor',
    // 상점 건당 관리비
    MGMT_FEE_PER_ORDER_FOR_DISTRIBUTOR: 'MGMT_fee_per_order',
    MGMT_FEE_PER_ORDER_FOR_HUB: 'MGMT_fee_per_order',
    MGMT_FEE_PER_ORDER_FOR_DISTRIBUTOR_REFUND: 'MGMT_fee_per_order',
    MGMT_FEE_PER_ORDER_FOR_HUB_REFUND: 'MGMT_fee_per_order',
    // 상점 수수료
    STORE_FEE_FOR_DISTRIBUTOR: 'store_fee',
    STORE_FEE_FOR_HUB: 'store_fee',
    STORE_FEE_FOR_DISTRIBUTOR_REFUND: 'store_fee',
    STORE_FEE_FOR_HUB_REFUND: 'store_fee',
    // 라이더 수수료 - WORKER_FEE_REFUND의 경우 category가 BT(HUB), WT(WORKER) 두가지 종류가 있음
    WORKER_FEE_FOR_ALLOCATED_HUB_FROM_HQ: 'worker_fee',
    WORKER_FEE_REFUND: 'worker_fee',
    WORKER_FEE: 'worker_fee',
    WORKER_FEE_FOR_ORDERED_HUB: 'worker_fee',
    // 봉사료 수수료
    SERVICE_CHARGE_FEE_FOR_ALLOCATED_HUB_REFUND: 'service_charge_fee',
    SERVICE_CHARGE_FEE_FOR_ORDERED_DISTRIBUTOR: 'service_charge_fee',
    SERVICE_CHARGE_FEE_FOR_ORDERED_HUB: 'service_charge_fee',
    SERVICE_CHARGE_FEE_FOR_ALLOCATED_HUB: 'service_charge_fee',
    SERVICE_CHARGE_FEE_FOR_ORDERED_DISTRIBUTOR_REFUND: 'service_charge_fee',
    SERVICE_CHARGE_FEE_FOR_ORDERED_HUB_REFUND: 'service_charge_fee',
    // 퀵 봉사료 수수료
    QUICK_SERVICE_CHARGE_FEE_FOR_ALLOCATED_HUB_REFUND: 'quick_service_charge_fee',
    QUICK_SERVICE_CHARGE_FEE_FOR_ORDERED_DISTRIBUTOR: 'quick_service_charge_fee',
    QUICK_SERVICE_CHARGE_FEE_FOR_ORDERED_HUB: 'quick_service_charge_fee',
    QUICK_SERVICE_CHARGE_FEE_FOR_ALLOCATED_HUB: 'quick_service_charge_fee',
    QUICK_SERVICE_CHARGE_FEE_FOR_ORDERED_DISTRIBUTOR_REFUND: 'quick_service_charge_fee',
    QUICK_SERVICE_CHARGE_FEE_FOR_ORDERED_HUB_REFUND: 'quick_service_charge_fee',
    // 허브 수수료 (본사 > 허브)
    HUB_FEE_FOR_ORDERED_HUB: 'hub_fee_for_ordered_hub',
    HUB_FEE_FOR_ORDERED_HUB_REFUND: 'hub_fee_for_ordered_hub',
    // 허브 수수료 (본사 > 총판)
    HUB_FEE_FOR_ORDERED_DISTRIBUTOR: 'hub_fee_for_ordered_distributor',
    HUB_FEE_FOR_ORDERED_DISTRIBUTOR_REFUND: 'hub_fee_for_ordered_distributor',
    // dep2. 상점 월 관리비
    MGMT_FEE_MONTHLY_FOR_DISTRIBUTOR: 'MGMT_fee_monthly',
    MGMT_FEE_MONTHLY_FOR_HUB: 'MGMT_fee_monthly',
    MGMT_FEE_MONTHLY_FOR_DISTRIBUTOR_REFUND: 'MGMT_fee_monthly',
    MGMT_FEE_MONTHLY_FOR_HUB_REFUND: 'MGMT_fee_monthly',
    // dep2. 라이더 정기공제 +
    // 출근비
    ATTEND_FEE_BY_RECURRING_PAYMENT: 'attend_fee_by_recurring_payment',
    // 프로그램 사용료
    PROGRAM_USE_BY_RECURRING_PAYMENT: 'program_use_by_recurring_payment',
    // dep2. 기타 수익 (주문채널유치)
    ORDER_CHANNEL_SALES_FEE_FOR_HUB: 'order_channel_sales_fee_for_hub',
    ORDER_CHANNEL_SALES_FEE_FOR_HUB_REFUND: 'order_channel_sales_fee_for_hub',
    // dep2.  라이더 보정 (라이더 > 허브)
    CORRECTION_FROM_HUB_MINUS: 'correction_from_hub_minus',
    // dep2. 보정 (본사 > 허브)
    CORRECTION_PLUS: 'correction_plus',
    // dep1. 총 비용
    // dep2. 배달 비용
    // 라이더 지원금
    SUPPORT_CHARGE: 'support_charge',
    // 라이더 수수료 (내허브 > 타허브)
    WORKER_FEE_FROM_ALLOCATED_HUB: 'worker_fee_for_other_hub',
    WORKER_FEE_FOR_OTHER_HUB_REFUND: 'worker_fee_for_other_hub',
    // 허브 수수료 (허브 > 본사)
    HUB_FEE_FOR_HQ: 'hub_fee_for_HQ',
    HUB_FEE_FOR_HQ_REFUND: 'hub_fee_for_HQ',
    // dep2. 상점 관리비 수수료
    MGMT_FEE_FOR_HQ: 'MGMT_fee_for_HQ',
    // dep2.  바이크 리스비 (허브 > 본사)
    LEASE_FOR_HQ: 'lease_fee_for_HQ',
    // dep2.  안심케어 (허브 > 본사)
    INSURANCE_FEE_FOR_HQ: 'insurance_fee_for_HQ',
    // dep2.  고용보험료 (허브 > 본사)
    EMPLOYMENT_INSURANCE_FEE_FOR_HQ: 'employment_insurance_fee_for_HQ',
    // dep2. 라이더 보정 (허브 > 라이더)
    CORRECTION_FROM_HUB_PLUS: 'correction_from_hub_plus',
    // dep2. 기타 비용
    // SMS 사용료
    SMS_FEE: 'SMS_fee',
    // MMS 사용료
    MMS_FEE: 'MMS_fee',
    // dep2.  보정 (허브 > 본사)
    CORRECTION_MINUS: 'correction_minus',
    // dep1. 기타
    // dep2.  부가세
    ADJUSTMENT_FEE: 'adjustment',
    ADJUSTMENT_VAT: 'adjustment',
    // dep2.  원천세 (라이더 > 허브)
    TAX: 'tax_refund',
    // dep2.  원천세 (라이더 > 허브)
    TAX_REFUND: 'tax_refund',
    // dep2.  원천세 (본사 > 허브)
    TAX_FROM_WORKER_REFUND: 'tax_from_worker',
    // dep2.  원천세 (본사 > 허브)
    TAX_FROM_WORKER: 'tax_from_worker',
    // dep2.  라이더 정기공제 -
    // 안심케어
    INSURANCE_FEE_BY_RECURRING_PAYMENT: 'insurance_fee_by_recurring_payment',
    // 바이크 리스비
    LEASE_BY_RECURRING_PAYMENT: 'lease_by_recurring_payment',
    // 패널티
    PENALTY_BY_RECURRING_PAYMENT: 'penalty_by_recurring_payment',
    // 기타
    ETC_BY_RECURRING_PAYMENT: 'etc_by_recurring_payment',
    // 책자배포비-배달대행
    CATALOG_DELIVERY: 'catalog_delivery',
    // 책자배포비-배달대행+퀵서비스
    CATALOG_DELIVERY_AND_QUICK: 'catalog_delivery_and_quick',
    // 책자배포비-퀵서비스
    CATALOG_QUICK: 'catalog_quick',
    // dep2.  입금
    DEPOSIT: 'deposit',
    // dep2.  출금
    WITHDRAWAL: 'withdrawal',
    // dep2.  송금 (받은 금액)
    WIRE_GET: 'wire_get',
    // dep2.  송금 (보낸 금액)
    WIRE_SEND: 'wire_send',
};
// depth3 항목과 depth2 항목 매핑하기
const depth3TitleTypeToDepth2List = {
    // dep2. 배달 수익
    // 선차감 수익
    margin_for_distributor: 'delivery_profit',
    // 상점 건당 관리비
    MGMT_fee_per_order: 'delivery_profit',
    // 상점 수수료
    store_fee: 'delivery_profit',
    // 라이더 수수료
    worker_fee: 'delivery_profit',
    // 봉사료 수수료
    service_charge_fee: 'delivery_profit',
    // 퀵 봉사료 수수료
    quick_service_charge_fee: 'delivery_profit',
    // 허브 수수료 (본사 > 허브)
    hub_fee_for_ordered_hub: 'delivery_profit',
    // client:허브 수수료 (본사 > 총판) = server:허브 수수료 (허브 > 총판)
    hub_fee_for_ordered_distributor: 'delivery_profit',
    // dep2. 상점 월 관리비
    MGMT_fee_monthly: 'MGMT_fee_monthly',
    // dep2. 라이더 정기공제 +
    // 출근비
    attend_fee_by_recurring_payment: 'regular_payment_for_worker_plus',
    // 프로그램 사용료
    program_use_by_recurring_payment: 'regular_payment_for_worker_plus',
    // dep2. 기타 수익 (주문채널유치)
    order_channel_sales_fee_for_hub: 'order_channel_sales_fee_for_hub',
    // dep2. 라이더 보정 (라이더 > 허브)
    correction_from_hub_minus: 'correction_from_hub_minus',
    // dep2. 보정 (본사 > 허브)
    correction_plus: 'correction_plus',
    // dep2. 배달 비용
    // 라이더 지원금
    support_charge: 'delivery_cost',
    // 라이더 수수료 (내허브 > 타허브)
    worker_fee_for_other_hub: 'delivery_cost',
    // 허브 수수료 (허브 > 본사)
    hub_fee_for_HQ: 'delivery_cost',
    // dep2. 상점 관리비 수수료
    MGMT_fee_for_HQ: 'MGMT_fee_for_HQ',
    // dep2.  바이크 리스비 (허브 > 본사)
    lease_fee_for_HQ: 'lease_fee_for_HQ',
    // dep2.  안심케어 (허브 > 본사)
    insurance_fee_for_HQ: 'insurance_fee_for_HQ',
    // dep2.  고용보험료 (허브 > 본사)
    employment_insurance_fee_for_HQ: 'employment_insurance_fee_for_HQ',
    // dep2.  라이더 보정 (허브 > 라이더)
    correction_from_hub_plus: 'correction_from_hub_plus',
    // dep2. 기타 비용
    // SMS 사용료
    SMS_fee: 'etc_cost',
    // MMS 사용료
    MMS_fee: 'etc_cost',
    // dep2.  보정 (허브 > 본사)
    correction_minus: 'correction_minus',
    // dep2.  부가세
    adjustment: 'adjustment',
    // dep2.  원천세 (라이더 > 허브)
    tax_refund: 'tax_refund',
    // dep2.  원천세 (본사 > 허브)
    tax_from_worker: 'tax_from_worker',
    // dep2. 라이더 정기공제 -
    // 안심케어
    insurance_fee_by_recurring_payment: 'regular_payment_for_worker_minus',
    // 바이크 리스비
    lease_by_recurring_payment: 'regular_payment_for_worker_minus',
    // 패널티
    penalty_by_recurring_payment: 'regular_payment_for_worker_minus',
    // 기타
    etc_by_recurring_payment: 'regular_payment_for_worker_minus',
    // dep2.  입금
    deposit: 'deposit',
    // dep2.  출금
    withdrawal: 'withdrawal',
    // dep2.  송금 (받은 금액)
    wire_get: 'wire_get',
    // dep2.  송금 (보낸 금액)
    wire_send: 'wire_send',
};
// depth2 항목과 depth1 항목 매핑하기
const depth2TitleTypeToDepth1List = {
    // 총 수익
    delivery_profit: 'total_profit',
    MGMT_fee_monthly: 'total_profit',
    regular_payment_for_worker_plus: 'total_profit',
    order_channel_sales_fee_for_hub: 'total_profit',
    correction_from_hub_minus: 'total_profit',
    correction_plus: 'total_profit',
    // 총 비용
    delivery_cost: 'total_cost',
    hub_fee_for_HQ: 'total_cost',
    MGMT_fee_for_HQ: 'total_cost',
    lease_fee_for_HQ: 'total_cost',
    insurance_fee_for_HQ: 'total_cost',
    employment_insurance_fee_for_HQ: 'total_cost',
    correction_from_hub_plus: 'total_cost',
    etc_cost: 'total_cost',
    correction_minus: 'total_cost',
    // 기타
    adjustment: 'etc',
    tax_refund: 'etc',
    tax_from_worker: 'etc',
    regular_payment_for_worker_minus: 'etc',
    deposit: 'etc',
    withdrawal: 'etc',
    wire_get: 'etc',
    wire_send: 'etc',
};
// 하위항목 포함 여부(expandable) 확인에 필요한 항목
const expandableDepth1TypeList = [
    'total_profit',
    'total_cost',
    'etc',
];
const expandableDepth2TypeList = [
    'delivery_profit',
    'regular_payment_for_worker_plus',
    'delivery_cost',
    'etc_cost',
    'regular_payment_for_worker_minus',
];
// 비용 항목 정렬에 필요한 항목
const costDepth3TypeList = [
    'support_charge',
    'worker_fee_for_other_hub',
    'hub_fee_for_HQ',
    'SMS_fee',
    'MMS_fee',
];
const costDepth2TypeList = [
    'delivery_cost',
    'hub_fee_for_HQ',
    'MGMT_fee_for_HQ',
    'lease_fee_for_HQ',
    'insurance_fee_for_HQ',
    'employment_insurance_fee_for_HQ',
    'correction_from_hub_plus',
    'etc_cost',
    'correction_minus',
];
// category 구분에 필요한 항목
// HUB catergory에 포함되는 항목
const onlyHubCategoryList = [
    'margin_for_distributor',
    'MGMT_fee_per_order',
    'store_fee',
    'service_charge_fee',
    'quick_service_charge_fee',
    'hub_fee_for_ordered_hub',
    'hub_fee_for_ordered_distributor',
    'MGMT_fee_monthly',
    'order_channel_sales_fee_for_hub',
    'correction_plus',
    'support_charge',
    'worker_fee_for_other_hub',
    'hub_fee_for_HQ',
    'MGMT_fee_for_HQ',
    'lease_fee_for_HQ',
    'insurance_fee_for_HQ',
    'employment_insurance_fee_for_HQ',
    'SMS_fee',
    'MMS_fee',
    'correction_minus',
    'adjustment',
    'tax_from_worker',
    'deposit',
    'withdrawal',
    'wire_get',
    'wire_send',
];
// WORKER catergory에 포함되는 항목
const onlyWorkerCategoryList = [
    'attend_fee_by_recurring_payment',
    'program_use_by_recurring_payment',
    'correction_from_hub_minus',
    'correction_from_hub_plus',
    'tax_refund',
    'insurance_fee_by_recurring_payment',
    'lease_by_recurring_payment',
    'panalty_by_recurring_payment',
    'etc_by_recurring_payment',
];
export { tableHeaders, reportTypeList, depth2TitleTypeToDepth1List, depth3TitleTypeToDepth2List, expandableDepth2TypeList, expandableDepth1TypeList, costDepth3TypeList, costDepth2TypeList, onlyHubCategoryList, onlyWorkerCategoryList, };
